export function validatePassword(password: string): string | undefined {
  const lowerBound = 9;
  if (password.length < lowerBound)
    return `Must be at least ${lowerBound} characters long`;
  if (!/[a-z]+/g.exec(password))
    return 'Must have at least one lowercase letter';
  if (!/[A-Z]+/g.exec(password))
    return 'Must have at least one uppercase letter';
  if (!/[0-9]+/g.exec(password)) return 'Must have at least one numeric digit';
  return undefined;
}
